module.exports = __webpack_public_path__ + "assets/89179c6a51f3f12e39ed82cd37edc76a.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/pick/WaitingVer2.mp3
 ** module id = 492
 ** module chunks = 0
 **/